export type TStickerResolutionPlacement = {
  width: number;
  height: number;
};

export type TStickerUpscaleWarning = {
  intrinsicWidth: number;
  intrinsicHeight: number;
  maximumDestinationWidth: number;
  maximumDestinationHeight: number;
  maximumScale: number;
};

export const getStickerUpscaleWarning = ({
  intrinsicWidth,
  intrinsicHeight,
  imageWidth,
  imageHeight,
  placements,
}: {
  intrinsicWidth: number;
  intrinsicHeight: number;
  imageWidth: number;
  imageHeight: number;
  placements: TStickerResolutionPlacement[];
}): TStickerUpscaleWarning | null => {
  if (
    intrinsicWidth <= 0 ||
    intrinsicHeight <= 0 ||
    imageWidth <= 0 ||
    imageHeight <= 0 ||
    placements.length === 0
  ) {
    return null;
  }

  const maximumDestinationWidth = Math.max(
    ...placements.map((placement) => placement.width * imageWidth),
  );
  const maximumDestinationHeight = Math.max(
    ...placements.map((placement) => placement.height * imageHeight),
  );
  const maximumScale = Math.max(
    maximumDestinationWidth / intrinsicWidth,
    maximumDestinationHeight / intrinsicHeight,
  );

  if (maximumScale <= 1) return null;

  return {
    intrinsicWidth,
    intrinsicHeight,
    maximumDestinationWidth: Math.ceil(maximumDestinationWidth),
    maximumDestinationHeight: Math.ceil(maximumDestinationHeight),
    maximumScale,
  };
};
